import { useMutation } from "@apollo/react-hooks";
import { Modal, Stack, TextField } from "@shopify/polaris";
import React, { useCallback, useRef, useState } from "react";

import { DIVISION_AMAZON_IDEA } from "../../../graphql/mutations/amazon-idea";
import { arrInvalid, handleError } from "../../../helper";
import useTimeout from "../../../hooks/useTimeout";
import { useToastContext } from "../../shared/ToastContext";
import AmazonIdeaSupporter from "../amazon-idea-supporter";
import { useAmazonIdeaCtx } from "../context";

export default function AmazonIdeaDivision({ open, onClose }) {
    const { setNotify, toggleToast } = useToastContext();
    const { refetch } = useAmazonIdeaCtx();
    const [state, setState] = useState("50");

    const [setDelay] = useTimeout();
    const [divisionAmazonIdea, { loading }] = useMutation(
        DIVISION_AMAZON_IDEA,
        {
            onCompleted: () => {
                setNotify({
                    msg: "Division amazon idea is being handled",
                    err: false,
                });

                onClose();
                setDelay(() => {
                    refetch && refetch();
                }, 1500);
            },
            onError: (err) => {
                setNotify({ msg: handleError(err?.toString()), err: true });
            },
        },
    );

    const supporterRef = useRef(null);
    const handleSubmit = useCallback(() => {
        if (supporterRef.current?.getSupporter) {
            const supporterIDs = supporterRef.current.getSupporter();
            if (!supporterIDs || arrInvalid(supporterIDs)) return;

            toggleToast && toggleToast(true);
            setNotify && setNotify({ msg: null, err: false });

            divisionAmazonIdea({
                variables: {
                    totalKpi: Number(state) || 50,
                    supporterIDs,
                },
            });
        }
    }, [state]);

    return (
        <Modal
            open={open}
            onClose={onClose}
            sectioned
            title="Amazon Idea Division"
            primaryAction={{
                content: "Submit",
                onAction: handleSubmit,
                loading: loading,
            }}
            secondaryActions={[{ content: "Cancel", onAction: onClose }]}
        >
            {open ? (
                <Stack vertical>
                    <TextField
                        label="Total kpi"
                        type="number"
                        value={state}
                        onChange={(state) => setState(state)}
                        placeholder="Enter total kpi"
                    />
                    <AmazonIdeaSupporter ref={supporterRef} allowMultiple />
                </Stack>
            ) : null}
        </Modal>
    );
}
